import { useState, useEffect } from 'react';
import {
  Box,
  Chip,
  Typography,
  Divider,
  FormControl,
  OutlinedInput,
  MenuItem,
  Select,
  InputLabel,
  alpha,
  Button,
} from '@mui/material';
import useTenantQuery from '@/hooks/useTenantQuery';

const AdminRoleSettings = ({ deployment, onSave }) => {
  const { data: roles } = useTenantQuery('role');
  const [selectedRoles, setselectedRoles] = useState(
    deployment?.config?.adminRoles,
  );
  const [error, setError] = useState(true);

  const handleUserChange = (event) => {
    setselectedRoles(event.target.value);
  };

  const handleRemoveUser = (userId) => {
    setselectedRoles((prevSelected) =>
      prevSelected.filter((id) => id !== userId),
    );
  };

  const handleSave = () => {
    if (selectedRoles.length === 0) {
      setError(true);
    } else {
      setError(false);
      onSave({ adminRoles: selectedRoles });
    }
  };

  useEffect(() => {
    if (selectedRoles.length === 0) {
      setError(true);
    } else {
      setError(false);
    }
  }, [selectedRoles.length]);

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: '20%',
      },
    },
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ my: 1, mb: 2, pr: '80px' }}>
        <Typography variant="h6">Adminrollen verwalten</Typography>
        <Divider />
      </Box>
      <Typography variant="body1" sx={{ mb: 3 }}>
        Wählen Sie die Adminrollen aus, die Zugriff auf {deployment.title} haben
        sollen.
      </Typography>

      <FormControl fullWidth variant="outlined">
        <InputLabel id="user-select-label">AdminRolle</InputLabel>
        <Select
          labelId="user-select-label"
          id="user-select"
          multiple
          value={selectedRoles}
          onChange={handleUserChange}
          MenuProps={MenuProps}
          input={<OutlinedInput id="select-multiple-chip" label="AdminRolle" />}
        >
          {roles.map((role) => (
            <MenuItem key={role._id} value={role._id}>
              {`${role.name}`}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {selectedRoles.length > 0 && (
        <Box sx={{ mt: 3 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Ausgewählte Rollen:
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 1,
              mt: 1,
              p: 2,
              borderRadius: 1,
              bgcolor: (theme) => alpha(theme.palette.background.default, 0.7),
            }}
          >
            {selectedRoles.map((roleId) => {
              const role = roles.find((r) => r._id === roleId);
              if (!role) return null;
              return (
                <Chip
                  key={role._id}
                  label={role.name}
                  onDelete={() => handleRemoveUser(roleId)}
                  color="primary"
                  variant="outlined"
                  sx={{ fontWeight: 500 }}
                />
              );
            })}
          </Box>
        </Box>
      )}

      {error && selectedRoles.length === 0 && (
        <Typography
          color="error"
          variant="caption"
          sx={{ display: 'block', mt: 1 }}
        >
          Bitte wählen Sie mindestens eine Rolle aus
        </Typography>
      )}
      <Button
        variant="contained"
        color="primary"
        onClick={handleSave}
        sx={{ mt: 'auto', ml: 'auto' }} // This pushes the button to the bottom right
      >
        Speichern
      </Button>
    </Box>
  );
};

export default AdminRoleSettings;
